import * as React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Container, Dropdown, Tabs, Tab, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import PageLoader from "../../../Common/Components/PageLoader";
import "react-toastify/dist/ReactToastify.css";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import filterFactory from "react-bootstrap-table2-filter";
import { FiChevronDown } from "react-icons/fi";
import { SingleSearchDropdownList } from "../../../Common/Components/SingleSearchDropdownList";
import OutsideClickHandler from "react-outside-click-handler";
import { TableCustomSearch } from "../../../Common/Components/TableCustomSearch";
import calenderGrey from "../../../Common/Assets/Images/icons/calendar_grey.svg"; // "../../../Common/Assets/Images/icons/calendar_grey.svg";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Hotel } from "../../../Common/Services/Hotel";
import { IHotelResponseDto } from "../../../Common/Contracts/IHotel";
import { LaborPerformance } from "../../../Common/Services/LaborPerfomance";
import { LaborTimeSheet } from "../../../Common/Services/LaborTimeSheet";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { LaborTimesheetDetail } from "./LaborTimesheetDetail";
import profile from "../../../Common/Assets/Images/profile.png";
import { resolve, reject } from "q";
import { HidSelector } from "../../../Common/Components/HidSelector";
// import TableSearch from "../../../Common/Components/TableSearch";
import { AddEntryModal } from "../Labor/Schedule/Modals & SlideOut/AddEntryModal";
import $ from "jquery";
import { Utils } from "../../../Common/Utilis";

// const { SearchBar } = Search;
export class LaborTimesheetTest extends React.Component<any, any> {
  private child: any;
  private childHID: any;
  private departmentSearch: any;
  constructor(props: any) {
    super(props);
    this.child = React.createRef();
    this.childHID = React.createRef();
    this.departmentSearch = React.createRef();
    this.state = {
      isDeepVisit: 1,
      hidValue: "Select",
      hotelName: "Select",
      hidList: [],
      timesheetDetails: [],
      navigationCalenderDates: [],
      filteredTimesheetDetails: [],
      timesheetStatus: [
        { id: "All", name: "All" },
        { id: "Approved", name: "Approved" },
        { id: "Disputed", name: "Disputed" },
        { id: "Waiting for Review", name: "Waiting for Review" },
        { id: "Manager Approved", name: "Manager Approved" },
      ],
      employeeTypeList: [],
      field: "userName",
      order: "asc",
      calenderShow: false,
      calenderDates: [],
      calenderSelectDate: "",
      key: "Overview",
      totalHours: "0:00",
      totalRegular: "0:00",
      totalOverTime: "0:00",
      totalDoubleOverTime: "0:00",
      totalTimeOff: "0:00",
      totalHoliday: "0:00",
      payPeriod: "",
      totalDisputed: 0,
      selectedStatus: "All",
      selectedEMPType: "All",
      ruleType: "Standard Rule",
      isHolidayShow: false,
      isSlideOutShow: false,
      slideOutData: [],
      searchedUser: "",

      newUser: [
        {
          deptID: 0,
          disputeStatus: "",
          doubleOverTime: "0:00",
          doubleOverTimeMin: 0,
          empType: "",
          grandDoubleOverTotal: "0:00",
          grandHolidayTotal: "0:00",
          grandOverTotal: "0:00",
          grandPTOTotal: "0:00",
          grandRegularTotal: "0:00",
          grandTotal: "0:00",
          id: 0,
          imagePath: "",
          overTime: "0:00",
          overTimeMin: 0,
          position: "",
          ruleType: "Standard Rule",
          userHolidayTotal: "0:00",
          userHolidayTotalMin: 0,
          userName: "",
          userPTOtotal: "0:00",
          userPTOtotalMin: 0,
          userRegularTotal: "0:00",
          userRegularTotalMin: 0,
          userTotal: "0:00",
          userTotalMins: 0,
          userUniqueno: 0,
        },
      ],
      searchItem: {},
      showAddEntryButton: false,

      showAddEntryModal: false,
      isDeepLinking: false,
      deepLinkingHotelCode: "",
      deepLink: [
        {
          id: "1",
          hotelID: "1441",
          lettercode: "FFCA",
          date: "8/13/2020",
          userName: "David.Smith",
          userUniqueno: "1918",
        },
      ],
    };
    // this.childHID.ref.onHotelClick = this.childHID.ref.onHotelClick.bind(this);
    this.handleSelectedItem = this.handleSelectedItem.bind(this);
    this.isSlideOutShow = this.isSlideOutShow.bind(this);
  }
  filteruser(item: any) {
    let filterData: any[] = [];
    let CopyData: any[] = [];
    let emp = item.employee;
    //let itemLength = Object.keys(item).length;
    CopyData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.timesheetDetails))
    );
    if (emp !== undefined) {
      filterData = CopyData.filter((e) => e.userName === item.employee);
      if (filterData.length > 0) {
        this.setState({ filteredTimesheetDetails: filterData });
      } else {
        // add user
        this.state.newUser[0].userName = item.employee;
        this.state.newUser[0].imagePath = item.imagePath;
        this.state.newUser[0].userUniqueno = 0;
        this.setState({ filteredTimesheetDetails: [] });
        this.setState({ filteredTimesheetDetails: this.state.newUser });
      }
    }
  }

  selectFromSearchBar = (type: any, item: any) => {
    let emp = item.employee;
    // let itemLength = Object.keys(item).length;
    if (emp === undefined) {
      this.setState({ searchedUser: "" }, () => {
        let CopyData: any[] = [];
        CopyData = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.timesheetDetails))
        );
        this.setState({ filteredTimesheetDetails: CopyData, searchItem: {} });
      });
    } else {
      this.setState({ searchedUser: item.employee }, () => {
        this.setState({ searchItem: item });
        this.filteruser(item);
      });
    }
  };
  CleanSearch = () => {
    if (this.child.current != null) {
      this.child.current.CleanSearch();
    }
  };

  hideSlideOut(data: any) {
    this.getTimeSheetOverViewDetails(
      this.state.hidValue,
      this.state.calenderSelectDate
    );
    this.setState({ isSlideOutShow: false });
  }

  handleOutsideClick() {
    this.setState({ isSlideOutShow: false });
  }

  componentDidMount() {
    let currentURL = window.location.href;
    if (currentURL.includes("?")) {
      this.setState({ isDeepLinking: true });
      sessionStorage.removeItem("hotelSelected");
      localStorage.removeItem("hotelSelected");
    } else {
      this.setState({ isDeepLinking: false });
    }

    this.getEmployeeType();
    setTimeout(() => {
      this.handleLoad();
    }, 2500);
  }

  getUrlParameter = (fullURL, name) => {
    name = name.replace(/[\\[]/, "\\[").replace(/[\]]/, "\\]");
    let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    let results = regex.exec(fullURL);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  };
  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  handleLoad = async () => {
    if (this.state.isDeepLinking) {
      let hotelDetails: any[] = [];
      let details = {} as any;

      Hotel.getUserHotelAccess("Labor Management")
        .then(async (result: IHotelResponseDto[] | null) => {
          if (result != null) {
            let x = result.filter(
              (items) =>
                items.hotelID ===
                parseInt(this.getUrlParameter(window.location.href, "H"))
            );
            details.ehidName = x[0].ehidName;
            details.hotelID = x[0].hotelID;
            details.hotelName = x[0].hotelName;
            details.hotelType = x[0].hotelType;
            details.lettercode = x[0].lettercode;
            details.tenantID = 0;
            details.timeZone = x[0].timeZone;
            hotelDetails.push(details);

            sessionStorage.setItem(
              "hotelSelected",
              JSON.stringify(hotelDetails[0])
            );
            this.selectHotelDropDown(hotelDetails[0]);
            await this.sleep(2000);

            this.calenderChange("");
            await this.sleep(3000);
            let rowData = this.state.filteredTimesheetDetails;
            let userDetails = rowData.filter(
              (t) =>
                t.userUniqueno ===
                Number(this.getUrlParameter(window.location.href, "U"))
            );
            if (userDetails.length > 0) {
              this.rowEvents.onClick("", userDetails[0], 0);
            } else {
              Utils.toastError("No shift found with this data.", {
                position: toast.POSITION.BOTTOM_RIGHT,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  loadHotelsDetails() {
    Hotel.getUserHotelAccess("Labor Management")
      .then(async (result: IHotelResponseDto[] | null) => {
        if (result != null) {
          this.setState({ hidList: result }, () => {});
        }
        resolve();
        this.setState({ loaderTrue: false });
      })
      .catch((error) => {
        this.setState({ loaderTrue: false });
        reject();
      });
  }

  selectHotelDropDown = (hotelDetails: any) => {
    // 
    // let deepURL = localStorage.getItem("deepURL");
    //let url = atob(String(deepURL));
    this.setState({ loaderTrue: true });
    let currentDate: any = new Date();
    currentDate.setDate(currentDate.getDate());
    let currentdate = currentDate.getDate();
    let currentMonth = currentDate.getMonth() + 1;
    let currentYear = currentDate.getFullYear();
    let tempDate = currentMonth + "/" + currentdate + "/" + currentYear;

    let ddlStatus: any[] = [];
    let ddlType: any[] = [];
    ddlStatus = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.timesheetStatus))
    );
    ddlType = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.employeeTypeList))
    );

    this.setState(
      {
        hotelName: hotelDetails.lettercode,
        hidValue: hotelDetails.hotelID,
        calenderSelectDate: tempDate,
        timesheetDetails: [],
        filteredTimesheetDetails: [],
        timesheetStatus: [],
        employeeTypeList: [],
        field: "userName",
        order: "asc",
        calenderShow: false,
        key: "Overview",
        totalHours: "0:00",
        totalRegular: "0:00",
        totalOverTime: "0:00",
        totalDoubleOverTime: "0:00",
        totalTimeOff: "0:00",
        totalHoliday: "0:00",
        payPeriod: "",
        totalDisputed: 0,
        selectedStatus: "All",
        selectedEMPType: "All",
        ruleType: "Standard Rule",
        isHolidayShow: false,
        isSlideOutShow: false,
        slideOutData: [],
        searchedUser: "",
        searchItem: {},
      },
      () =>
        this.setState({
          timesheetStatus: ddlStatus,
          employeeTypeList: ddlType,
        })
    );
    this.getPayPeroid(tempDate, hotelDetails.hotelID);

    if (this.departmentSearch.current !== null) {
      $("#btnremove").click();
    }

    this.CleanSearch();
  };

  getEmployeeType = () => {
    // 
    this.setState({ loaderTrue: true });
    LaborTimeSheet.getEmployeeType()
      .then(async (result: any[] | null) => {
        this.setState({ loaderTrue: false });
        let employeeType: any[] = [{ id: "All", name: "All" }];
        if (result !== null) {
          result.forEach((element) => {
            let data = {} as any;
            data.id = element.employeetype;
            data.name = element.displayName;
            employeeType.push(data);
          });
        }
        this.setState({ employeeTypeList: employeeType });
        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({ loaderTrue: false });
      });
    this.setState({
      timesheetStatus: [
        { id: "All", name: "All" },
        { id: "Approved", name: "Approved" },
        { id: "Disputed", name: "Disputed" },
        { id: "Waiting for Review", name: "Waiting for Review" },
        { id: "Manager Approved", name: "Manager Approved" },
      ],
    });
  };

  getPayPeroid(selectedDate: any, hotelID: Number) {
    LaborPerformance.getPayPeriodDates(hotelID, selectedDate, "Weekly").then(
      async (result: any[] | null) => {
        if (result != null) {
          this.setState(
            {
              calenderDates: [result[0].startdate, result[0].enddate],
              payPeriod: result[0].startEndDate,
              ruleType: result[0].ruleType,
            },
            () => {
              this.departmentSearch.current.getSearchUsersList();
              this.hasLaborApprovalStatusPendingForWeek();
              // if (this.departmentSearch.current !== null) {
              //     this.departmentSearch.current.getSearchUsersList();
              //   }
            }
          );
          this.getTotalDisputed(
            hotelID,
            result[0].startdate,
            result[0].enddate
          );
          this.getTimeSheetOverViewDetails(hotelID, selectedDate);
          this.CleanSearch();
        }
      }
    );
  }

  getTimeSheetOverViewDetails(hotelID: Number, selectedDate: any) {
    //
    LaborTimeSheet.timeSheetOverViewDetails(hotelID, selectedDate).then(
      async (result: any[] | null) => {
        if (result != null) {
          // 
          this.setState({
            filteredTimesheetDetails: result,
            timesheetDetails: result,
          });
          if (result.length > 0) {
            this.setState({
              totalHours: result[0].grandTotal,
              totalRegular: result[0].grandRegularTotal,
              totalOverTime: result[0].grandOverTotal,
              totalDoubleOverTime: result[0].grandDoubleOverTotal,
              totalTimeOff: result[0].grandPTOTotal,
              totalHoliday: result[0].grandHolidayTotal,
              isHolidayShow:
                result[0].grandHolidayTotal === "0:00" ? false : true,
            });
            if (this.state.searchedUser !== "") {
              this.filteruser(this.state.searchItem);
            }
          } else {
            this.setState({
              totalHours: "0:00",
              totalRegular: "0:00",
              totalOverTime: "0:00",
              totalDoubleOverTime: "0:00",
              totalTimeOff: "0:00",
              totalHoliday: "0:00",
              isHolidayShow: false,
            });

            if (this.state.searchedUser !== "") {
              this.filteruser(this.state.searchItem);
            }
          }
        }
      }
    );
  }

  getTotalDisputed(hotelID: Number, payStartDate: any, payEndDate: any) {
    LaborTimeSheet.getDisputeTotal(hotelID, payStartDate, payEndDate).then(
      async (result: any[] | null) => {
        if (result != null) {
          this.setState({ totalDisputed: result });
        }
      }
    );
  }

  handleSelectedItem = (controlID: any, id: any) => {
    if (controlID === 1) {
      this.setState({ selectedStatus: id });
      this.FilterByDropDownList(id, this.state.selectedEMPType);
    } else {
      this.setState({ selectedEMPType: id });
      this.FilterByDropDownList(this.state.selectedStatus, id);
    }
  };

  FilterByDropDownList(selectedStatus: any, selectedEMPType: any) {
    let filterData: any[] = [];
    filterData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.timesheetDetails))
    );
    if (selectedStatus !== "All") {
      filterData = filterData.filter(
        (item) => item.disputeStatus === selectedStatus
      );
    }
    if (selectedEMPType !== "All") {
      filterData = filterData.filter(
        (item) => item.empType === selectedEMPType
      );
    }
    this.setState({ filteredTimesheetDetails: filterData });
  }

  calenderHide = () => {
    this.setState({ calenderShow: false });
  };

  calenderShow = () => {
    this.setState({ calenderShow: true });
  };

  calenderChange = (e: any) => {
    //
    let calenderYear = "";
    let calenderDate = "";
    let calenderMonth = "";
    let tempDate = "";
    if (this.state.isDeepLinking && e === "") {
      tempDate = this.getUrlParameter(window.location.href, "P");
    } else {
      calenderYear = e.getFullYear();
      calenderDate = e.getDate();
      calenderMonth = e.getMonth() + 1;
      tempDate = calenderMonth + "/" + calenderDate + "/" + calenderYear;
    }

    let ddlStatus: any[] = [];
    let ddlType: any[] = [];
    ddlStatus = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.timesheetStatus))
    );
    ddlType = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.employeeTypeList))
    );
    this.setState(
      {
        calenderSelectDate: tempDate,
        timesheetDetails: [],
        filteredTimesheetDetails: [],
        timesheetStatus: [],
        employeeTypeList: [],
        field: "userName",
        order: "asc",
        calenderShow: false,
        key: "Overview",
        totalHours: "0:00",
        totalRegular: "0:00",
        totalOverTime: "0:00",
        totalDoubleOverTime: "0:00",
        totalTimeOff: "0:00",
        totalHoliday: "0:00",
        payPeriod: "",
        totalDisputed: 0,
        selectedStatus: "All",
        selectedEMPType: "All",
        ruleType: "Standard Rule",
        isHolidayShow: false,
        isSlideOutShow: false,
        slideOutData: [],
      },
      () =>
        this.setState({ timesheetStatus: ddlStatus, employeeTypeList: ddlType })
    );
    this.getPayPeroid(tempDate, this.state.hidValue);
  };

  isSlideOutShow(data: any) {
    let newItem: any = {};
    newItem.hotelID = this.state.hidValue;
    newItem.hotelName = this.state.hotelName;
    newItem.userUniqueno = data.userUniqueno;
    newItem.userName = data.userName;
    newItem.payPeriod = this.state.payPeriod;
    newItem.date = this.state.calenderSelectDate;
    newItem.ruleType = this.state.ruleType;
    newItem.imagePath = data.imagePath;
    newItem.fullDate = this.state.calenderDates;
    newItem.position = data.position;
    this.setState({
      slideOutData: newItem,
      isSlideOutShow: true,
      isDeepVisit: 2,
    });
    // if (this.state.isDeepLinking) {
    //   let el: any = "";
    //   

    //   el = document.getElementById("4");

    //   //this.sleep(5000);
    //   alert($("#4").html());
    //   $("#4").animate({ scrollTop: "100px" }, 1000);
    //   //el.scrollTop = 0;
    // }
  }

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      this.isSlideOutShow(row);
    },
  };

  hasLaborApprovalStatusPendingForWeek = () => {
    const { hidValue, calenderDates } = this.state;
    LaborPerformance.hasLaborApprovalStatusPendingForWeek(
      hidValue,
      calenderDates[0],
      calenderDates[1]
    )
      .then((status) => {
        this.setState({
          showAddEntryButton: status,
        });
      })
      .catch((error) => {
        this.setState({
          showAddEntryButton: true,
        });
      });
  };

  showAddEntryModal = (e: any) => {
    // let hid = this.state.hidValue
    this.setState({
      showAddEntryModal: true,
    });
  };
  hideAddEntryModal = () => {
    this.setState({
      showAddEntryModal: false,
    });
  };
  addEntryRefresh = () => {
    this.setState({
      showAddEntryModal: false,
    });
    this.getTimeSheetOverViewDetails(
      this.state.hidValue,
      this.state.calenderSelectDate
    );
  };
  render() {
    const handleSelect = (eventKey: any) => {
      this.setState({ key: eventKey });
    };

    const columns = [
      {
        dataField: "userName",
        text: "userName",
        hidden: true,
        sort: true,
      },
      {
        dataField: "",
        text: "Name",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <>
              <div>
                <div className="d-flex">
                  <div className="profile-img">
                    <img
                      src={
                        row.imagePath === null
                          ? profile
                          : row.imagePath.trim() === ""
                          ? profile
                          : row.imagePath
                      }
                      className={
                        row.imagePath === null
                          ? "default"
                          : row.imagePath.trim() === ""
                          ? "default"
                          : ""
                      }
                      width="40"
                      height="40"
                      alt={row.userName}
                    />
                  </div>
                  <div>
                    <div className="main-ttl">
                      <EllipsisWithTooltip placement="bottom">
                        {row.userName}
                      </EllipsisWithTooltip>
                    </div>
                    <div className="sub-ttl">
                      <EllipsisWithTooltip placement="bottom">
                        {row.position}
                      </EllipsisWithTooltip>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },
      {
        dataField: "",
        text: "Status",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="d-flex flex-wrap">
              {row.disputeStatus !== "" && row.disputeStatus !== null && (
                <>
                  {row.disputeStatus === "Approved" && (
                    <div className="red-badges green-bg">
                      {row.disputeStatus}
                    </div>
                  )}
                  {row.disputeStatus === "Disputed" && (
                    <div className="red-badges orange-bg">
                      {row.disputeStatus}
                    </div>
                  )}
                  {row.disputeStatus === "Waiting for Review" && (
                    <div className="red-badges blue-bg">
                      {row.disputeStatus}
                    </div>
                  )}
                  {row.disputeStatus === "Manager Approved" && (
                    <div className="red-badges green-bg">
                      {row.disputeStatus}
                    </div>
                  )}
                </>
              )}
            </div>
          );
        },
      },

      {
        dataField: "",
        text: "Total Hours",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="d-flex flex-wrap thours">
              {row.userTotal !== "0:00" && (
                <div className="main-ttl">{row.userTotal}</div>
              )}
              {row.userTotal === "0:00" && (
                <div className="main-ttl">{"-"}</div>
              )}
            </div>
          );
        },
      },
      {
        dataField: "",
        text: "Regular",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="d-flex flex-wrap">
              {row.userRegularTotal !== "0:00" && (
                <div className="main-ttl">{row.userRegularTotal}</div>
              )}
              {row.userRegularTotal === "0:00" && (
                <div className="main-ttl">{"-"}</div>
              )}
            </div>
          );
        },
      },
      {
        dataField: "",
        text: "OT",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="d-flex flex-wrap">
              {row.overTime !== "0:00" && (
                <div className="main-ttl">{row.overTime}</div>
              )}
              {row.overTime === "0:00" && <div className="main-ttl">{"-"}</div>}
            </div>
          );
        },
      },
      {
        dataField: "",
        text: "DOT",
        hidden: this.state.ruleType === "Standard Rule" ? true : false,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="d-flex flex-wrap">
              {row.doubleOverTime !== "0:00" && (
                <div className="main-ttl">{row.doubleOverTime}</div>
              )}
              {row.doubleOverTime === "0:00" && (
                <div className="main-ttl">{"-"}</div>
              )}
            </div>
          );
        },
      },
      {
        dataField: "",
        text: "PTO",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="d-flex flex-wrap">
              {row.userPTOtotal !== "0:00" && (
                <div className="main-ttl">{row.userPTOtotal}</div>
              )}
              {row.userPTOtotal === "0:00" && (
                <div className="main-ttl">{"-"}</div>
              )}
            </div>
          );
        },
      },
      {
        dataField: "userHolidayTotal",
        text: "Holiday",
        hidden: !this.state.isHolidayShow,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="d-flex flex-wrap">
              {row.userHolidayTotal !== "0:00" && (
                <div className="main-ttl">{row.userHolidayTotal}</div>
              )}
              {row.userHolidayTotal === "0:00" && (
                <div className="main-ttl">{"-"}</div>
              )}
            </div>
          );
        },
      },
      {
        dataField: "action",
        text: "",
        editable: false,
        formatter: (cell: any, row: any, rowIndex: any) => (
          <Dropdown className="more-action" alignRight>
            <Dropdown.Toggle
              className="btn-outline-primary btn btn-primary more"
              id="dropdown-more"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey={"Dummy Text"}>Dummy Text</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ),
      },
    ];

    var loadShow: any;
    if (this.state.loaderTrue) {
      loadShow = <PageLoader />;
    }
    return (
      <>
        {this.state.isSlideOutShow && (
          <OutsideClickHandler onOutsideClick={this.handleOutsideClick}>
            <LaborTimesheetDetail
              data={this.state.slideOutData}
              hideSlideOut={this.hideSlideOut.bind(this)}
            />
          </OutsideClickHandler>
        )}
        <div className="performance-position performance timesheet">
          {/* <ToastContainer autoClose={3000} /> */}
          {loadShow}
          <Container fluid className="body-sec">
            <div className="page-heading d-flex mrgn-btm">
              <HidSelector
                onClickEvent={this.selectHotelDropDown}
                ref={this.childHID}
                //{...this.state.deepLinkingHotelCode}
                //{...this.props.onHotelClick}
              />
              <div className="mr-auto d-flex align-items-center">
                Timesheets
              </div>
              <div className="action-group d-flex flex-row">
                {this.state?.showAddEntryButton && (
                  <Button
                    className="add-shift btn-outline-primary"
                    onClick={(e: any) => this.showAddEntryModal(e)}
                  >
                    Add Entry
                  </Button>
                )}
              </div>
            </div>
            {this.state.hidValue !== "Select" && (
              <Tabs
                id="controlled-tab-example"
                activeKey={this.state.key}
                onSelect={handleSelect}
              >
                <Tab eventKey="Overview" title="Overview">
                  <div className="main-Page">
                    <div className="bdy-sec">
                      <ToolkitProvider
                        keyField="userUniqueno"
                        data={this.state.filteredTimesheetDetails}
                        columns={columns}
                        rowEvents={this.rowEvents}
                        sort={{
                          dataField: this.state.field,
                          order: this.state.order,
                        }}
                        search
                      >
                        {(props: {
                          searchProps: JSX.IntrinsicAttributes;
                          baseProps: JSX.IntrinsicAttributes;
                        }) => (
                          <div>
                            <div className="search-header d-flex">
                              <div className="schedule-main">
                                <div className="schedule-department-view-table">
                                  <div className="departmentViewNavigation">
                                    <div className="navigation-menus d-flex">
                                      <div className="schedule-table-search">
                                        <TableCustomSearch
                                          id="mainView"
                                          component="timesheet"
                                          ref={this.departmentSearch}
                                          parentState={this.state}
                                          hidValue={this.state.hidValue}
                                          selectFromSearchBar={this.selectFromSearchBar.bind(
                                            this,
                                            "mainView"
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* <TableSearch
                                                                    id="tableSearch"
                                                                    key="tableSearch"
                                                                    ref={this.child}
                                                                    {...props.searchProps}
                                                                    CleanSearch={this.CleanSearch.bind(this)}
                                                                    placeholder={"Search..."}
                                                                /> */}
                              <div className="">
                                <div
                                  className="calender-display date-picker d-flex align-items-center"
                                  onClick={this.calenderShow}
                                >
                                  <span>
                                    <img
                                      className="calender-icon"
                                      src={calenderGrey}
                                      alt="Calender Arrow"
                                    />
                                  </span>
                                  <span className="prev-Date">
                                    {this.state.calenderDates[0]}
                                  </span>
                                  <span className="seperator"> - </span>
                                  <span className="next-Date">
                                    {this.state.calenderDates[1]}
                                  </span>
                                  <span className="chevron-down">
                                    <FiChevronDown />
                                  </span>
                                </div>
                                {this.state.calenderShow && (
                                  <div className="calender">
                                    <OutsideClickHandler
                                      onOutsideClick={this.calenderHide}
                                    >
                                      <Calendar
                                       calendarType={"US"}
                                        onChange={this.calenderChange}
                                        value={
                                          new Date(
                                            this.state.calenderSelectDate
                                          )
                                        }
                                        maxDate={JSON.parse(localStorage.storage).currentUtcTime !== "" ? new Date(
                                          JSON.parse(localStorage.storage).currentUtcTime
                                        ):new Date()}
                                      />
                                    </OutsideClickHandler>
                                  </div>
                                )}
                              </div>

                              <div className="position-filter">
                                {this.state.timesheetStatus.length > 0 && (
                                  <SingleSearchDropdownList
                                    itemList={this.state.timesheetStatus}
                                    handleSelectedItem={this.handleSelectedItem.bind(
                                      this,
                                      1
                                    )}
                                    defaultItem={this.state.timesheetStatus}
                                    defaultText={"Search Timesheet Status"}
                                    defaultName={"Timesheet Status"}
                                    controlID="1"
                                  />
                                )}
                              </div>
                              <div className="mr-auto department-filter">
                                {this.state.employeeTypeList.length > 0 && (
                                  <SingleSearchDropdownList
                                    itemList={this.state.employeeTypeList}
                                    handleSelectedItem={this.handleSelectedItem.bind(
                                      this,
                                      2
                                    )}
                                    defaultItem={this.state.employeeTypeList}
                                    defaultText={"Search Employee Type"}
                                    defaultName={"Employee Type"}
                                    controlID="2"
                                  />
                                )}
                              </div>
                            </div>

                            <div className="d-flex details-sec">
                              <div className="flex-fill align-content-center box">
                                <div className="title">
                                  {this.state.payPeriod}
                                </div>
                                <div className="list">
                                  <ul>
                                    <li>
                                      <div className="ttl">
                                        {this.state.totalHours}
                                      </div>
                                      <div className="desc">Total Hours</div>
                                    </li>
                                    <li>
                                      <div className="ttl">
                                        {this.state.totalRegular}
                                      </div>
                                      <div className="desc">Regular</div>
                                    </li>
                                    <li>
                                      <div className="ttl">
                                        {this.state.totalOverTime}
                                      </div>
                                      <div className="desc">Overtime</div>
                                    </li>
                                    {this.state.ruleType !==
                                      "Standard Rule" && (
                                      <li>
                                        <div className="ttl">
                                          {this.state.totalDoubleOverTime}
                                        </div>
                                        <div className="desc">
                                          Double Overtime
                                        </div>
                                      </li>
                                    )}
                                    <li>
                                      <div className="ttl">
                                        {this.state.totalTimeOff}
                                      </div>
                                      <div className="desc">PTO</div>
                                    </li>
                                    {this.state.isHolidayShow && (
                                      <li>
                                        <div className="ttl">
                                          {this.state.totalHoliday}
                                        </div>
                                        <div className="desc">Holiday</div>
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                              <div className="flex-fill align-content-center box">
                                <div className="title">All Disputes</div>
                                <div className="list">
                                  <ul>
                                    <li>
                                      <div className="d-flex">
                                        <div className="calender-icon">
                                          <svg
                                            width="64"
                                            height="64"
                                            viewBox="0 0 64 64"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <circle
                                              cx="32"
                                              cy="32"
                                              r="32"
                                              fill="#FFF3E8"
                                            />
                                            <path
                                              d="M44.7606 19.7609C44.6712 18.9634 44.4674 18.2228 44.1643 17.6166C43.6431 16.5741 42.8744 16 42 16C41.1256 16 40.3569 16.5741 39.8357 17.6166C39.5339 18.2201 39.3307 18.9566 39.2406 19.75H38.0928C38.0027 18.9566 37.7994 18.2201 37.4977 17.6166C36.9764 16.5741 36.2078 16 35.3333 16C34.4588 16 33.6902 16.5741 33.1689 17.6166C32.8672 18.2201 32.664 18.9566 32.5739 19.75H31.426C31.3359 18.9566 31.1327 18.2201 30.831 17.6166C30.3098 16.5741 29.5411 16 28.6667 16C27.7923 16 27.0236 16.5741 26.5024 17.6166C26.2006 18.2201 25.9974 18.9566 25.9073 19.75H24.7594C24.6693 18.9566 24.4661 18.2201 24.1643 17.6166C23.6431 16.5741 22.8744 16 22 16C21.1256 16 20.3569 16.5741 19.8357 17.6166C19.5326 18.2228 19.3288 18.9634 19.2394 19.7609C17.4653 19.8947 16.0625 21.3798 16.0625 23.1875V44.5625C16.0625 46.4579 17.6046 48 19.5 48H44.5C46.3954 48 47.9375 46.4579 47.9375 44.5625V23.1875C47.9375 21.3798 46.5347 19.8947 44.7606 19.7609ZM41.5127 18.4551C41.7524 17.9758 41.9676 17.875 42 17.875C42.0324 17.875 42.2476 17.9758 42.4873 18.4551C42.6649 18.8103 42.7954 19.2586 42.8689 19.75H41.1311C41.2046 19.2586 41.3351 18.8103 41.5127 18.4551ZM34.8461 18.4551C35.0857 17.9758 35.3009 17.875 35.3334 17.875C35.3658 17.875 35.581 17.9758 35.8207 18.4551C35.9983 18.8103 36.1287 19.2586 36.2022 19.75H34.4645C34.538 19.2586 34.6684 18.8103 34.8461 18.4551ZM28.1794 18.4551C28.419 17.9758 28.6343 17.875 28.6667 17.875C28.6991 17.875 28.9144 17.9758 29.154 18.4551C29.3316 18.8103 29.4621 19.2586 29.5356 19.75H27.7978C27.8713 19.2586 28.0017 18.8103 28.1794 18.4551ZM22 17.875C22.0324 17.875 22.2476 17.9758 22.4873 18.4551C22.6649 18.8103 22.7954 19.2586 22.8689 19.75H21.1311C21.2046 19.2586 21.3351 18.8103 21.5127 18.4551C21.7524 17.9758 21.9676 17.875 22 17.875ZM17.9375 23.1875C17.9375 22.4134 18.5034 21.7694 19.2431 21.6465C19.3343 22.4317 19.5366 23.1604 19.8356 23.7584C20.3569 24.8009 21.1256 25.375 22 25.375C22.5177 25.375 22.9375 24.9552 22.9375 24.4375C22.9375 23.9198 22.5177 23.5 22 23.5C21.9676 23.5 21.7524 23.3992 21.5127 22.9199C21.3351 22.5647 21.2046 22.1164 21.1311 21.625H25.9073C25.9973 22.4184 26.2006 23.1549 26.5023 23.7584C27.0236 24.8009 27.7922 25.375 28.6666 25.375C29.1844 25.375 29.6041 24.9552 29.6041 24.4375C29.6041 23.9198 29.1844 23.5 28.6666 23.5C28.6342 23.5 28.419 23.3992 28.1793 22.9199C28.0017 22.5647 27.8713 22.1164 27.7978 21.625H32.5739C32.664 22.4184 32.8673 23.1549 33.1689 23.7584C33.6902 24.8009 34.4588 25.375 35.3333 25.375C35.8511 25.375 36.2708 24.9552 36.2708 24.4375C36.2708 23.9198 35.8511 23.5 35.3333 23.5C35.3009 23.5 35.0856 23.3992 34.846 22.9199C34.6684 22.5647 34.5379 22.1164 34.4644 21.625H39.2406C39.3306 22.4184 39.5339 23.1549 39.8356 23.7584C40.3569 24.8009 41.1256 25.375 42 25.375C42.5177 25.375 42.9375 24.9552 42.9375 24.4375C42.9375 23.9198 42.5177 23.5 42 23.5C41.9676 23.5 41.7524 23.3992 41.5127 22.9199C41.3351 22.5647 41.2046 22.1164 41.1311 21.625H44.5C45.3616 21.625 46.0625 22.3259 46.0625 23.1875V27.375H17.9375V23.1875ZM46.0625 44.5625C46.0625 45.4241 45.3616 46.125 44.5 46.125H19.5C18.6384 46.125 17.9375 45.4241 17.9375 44.5625V29.25H46.0625V44.5625Z"
                                              fill="#863902"
                                            />
                                            <path
                                              d="M26.7464 36.1093C26.9295 36.2924 27.1694 36.384 27.4093 36.384C27.6491 36.384 27.8891 36.2924 28.0721 36.1093L28.7351 35.4464L29.398 36.1093C29.5811 36.2924 29.821 36.384 30.0609 36.384C30.3008 36.384 30.5408 36.2924 30.7238 36.1093C31.0899 35.7433 31.0899 35.1497 30.7238 34.7835L30.0608 34.1206L30.7238 33.4577C31.0899 33.0916 31.0899 32.498 30.7238 32.1318C30.3577 31.7658 29.7641 31.7658 29.398 32.1318L28.735 32.7948L28.0721 32.1318C27.706 31.7658 27.1124 31.7658 26.7463 32.1318C26.3801 32.4979 26.3801 33.0915 26.7463 33.4577L27.4092 34.1206L26.7463 34.7835C26.3803 35.1497 26.3803 35.7433 26.7464 36.1093Z"
                                              fill="#863902"
                                            />
                                            <path
                                              d="M26.7464 43.2431C26.9295 43.4262 27.1694 43.5178 27.4093 43.5178C27.6491 43.5178 27.8891 43.4262 28.0721 43.2431L28.7351 42.5802L29.398 43.2431C29.5811 43.4262 29.821 43.5178 30.0609 43.5178C30.3008 43.5178 30.5408 43.4262 30.7238 43.2431C31.0899 42.8771 31.0899 42.2834 30.7238 41.9173L30.0608 41.2544L30.7238 40.5914C31.0899 40.2254 31.0899 39.6318 30.7238 39.2656C30.3577 38.8996 29.7641 38.8996 29.398 39.2656L28.735 39.9286L28.0721 39.2656C27.706 38.8996 27.1124 38.8996 26.7463 39.2656C26.3801 39.6317 26.3801 40.2253 26.7463 40.5914L27.4092 41.2544L26.7463 41.9173C26.3803 42.2834 26.3803 42.877 26.7464 43.2431Z"
                                              fill="#863902"
                                            />
                                            <path
                                              d="M33.2767 36.1093C33.4597 36.2924 33.6997 36.384 33.9395 36.384C34.1794 36.384 34.4194 36.2924 34.6024 36.1093L35.2654 35.4464L35.9283 36.1093C36.1114 36.2924 36.3513 36.384 36.5912 36.384C36.8311 36.384 37.0711 36.2924 37.2541 36.1093C37.6202 35.7433 37.6202 35.1497 37.2541 34.7835L36.5911 34.1206L37.2541 33.4577C37.6202 33.0916 37.6202 32.498 37.2541 32.1318C36.888 31.7658 36.2944 31.7658 35.9282 32.1318L35.2653 32.7948L34.6024 32.1318C34.2363 31.7658 33.6427 31.7658 33.2765 32.1318C32.9104 32.4979 32.9104 33.0915 33.2765 33.4577L33.9395 34.1206L33.2765 34.7835C32.9105 35.1497 32.9105 35.7433 33.2767 36.1093Z"
                                              fill="#863902"
                                            />
                                            <path
                                              d="M33.2767 43.2431C33.4597 43.4262 33.6997 43.5178 33.9395 43.5178C34.1794 43.5178 34.4194 43.4262 34.6024 43.2431L35.2654 42.5802L35.9283 43.2431C36.1114 43.4262 36.3513 43.5178 36.5912 43.5178C36.8311 43.5178 37.0711 43.4262 37.2541 43.2431C37.6202 42.8771 37.6202 42.2834 37.2541 41.9173L36.5911 41.2544L37.2541 40.5914C37.6202 40.2254 37.6202 39.6318 37.2541 39.2656C36.888 38.8996 36.2944 38.8996 35.9282 39.2656L35.2653 39.9286L34.6024 39.2656C34.2363 38.8996 33.6427 38.8996 33.2765 39.2656C32.9104 39.6317 32.9104 40.2253 33.2765 40.5914L33.9395 41.2544L33.2765 41.9173C32.9105 42.2834 32.9105 42.877 33.2767 43.2431Z"
                                              fill="#863902"
                                            />
                                            <path
                                              d="M39.8069 36.1093C39.99 36.2924 40.2299 36.384 40.4698 36.384C40.7097 36.384 40.9497 36.2924 41.1327 36.1093L41.7956 35.4464L42.4586 36.1093C42.6416 36.2925 42.8815 36.384 43.1214 36.384C43.3613 36.384 43.6013 36.2924 43.7843 36.1093C44.1504 35.7433 44.1504 35.1497 43.7843 34.7835L43.1214 34.1206L43.7843 33.4576C44.1504 33.0916 44.1504 32.498 43.7843 32.1318C43.4182 31.7658 42.8246 31.7658 42.4585 32.1318L41.7956 32.7948L41.1326 32.1318C40.7665 31.7657 40.1729 31.7657 39.8068 32.1318C39.4407 32.4979 39.4407 33.0915 39.8068 33.4576L40.4698 34.1206L39.8068 34.7835C39.4408 35.1497 39.4408 35.7433 39.8069 36.1093Z"
                                              fill="#863902"
                                            />
                                            <path
                                              d="M20.2161 36.1093C20.3992 36.2924 20.6391 36.384 20.879 36.384C21.1189 36.384 21.3589 36.2924 21.5419 36.1093L22.2048 35.4464L22.8678 36.1093C23.0508 36.2925 23.2907 36.384 23.5306 36.384C23.7705 36.384 24.0105 36.2924 24.1935 36.1093C24.5596 35.7433 24.5596 35.1497 24.1935 34.7835L23.5306 34.1206L24.1935 33.4576C24.5596 33.0916 24.5596 32.498 24.1935 32.1318C23.8274 31.7658 23.2338 31.7658 22.8677 32.1318L22.2048 32.7948L21.5418 32.1318C21.1758 31.7657 20.5822 31.7657 20.216 32.1318C19.8499 32.4979 19.8499 33.0915 20.216 33.4576L20.8789 34.1206L20.216 34.7835C19.85 35.1497 19.85 35.7433 20.2161 36.1093Z"
                                              fill="#863902"
                                            />
                                            <path
                                              d="M20.2161 43.2432C20.3992 43.4263 20.6391 43.5178 20.879 43.5178C21.1189 43.5178 21.3589 43.4263 21.5419 43.2432L22.2048 42.5803L22.8678 43.2432C23.0508 43.4263 23.2907 43.5178 23.5306 43.5178C23.7705 43.5178 24.0105 43.4263 24.1935 43.2432C24.5596 42.8771 24.5596 42.2835 24.1935 41.9174L23.5306 41.2544L24.1935 40.5915C24.5596 40.2254 24.5596 39.6318 24.1935 39.2657C23.8274 38.8996 23.2338 38.8996 22.8677 39.2657L22.2048 39.9286L21.5418 39.2657C21.1758 38.8996 20.5822 38.8996 20.216 39.2657C19.8499 39.6317 19.8499 40.2254 20.216 40.5915L20.8789 41.2544L20.216 41.9174C19.85 42.2834 19.85 42.8771 20.2161 43.2432Z"
                                              fill="#863902"
                                            />
                                            <path
                                              d="M41.7959 42.1921C42.3137 42.1921 42.7334 41.7723 42.7334 41.2546C42.7334 40.7368 42.3137 40.3171 41.7959 40.3171C41.2781 40.3171 40.8584 40.7368 40.8584 41.2546C40.8584 41.7723 41.2781 42.1921 41.7959 42.1921Z"
                                              fill="#863902"
                                            />
                                          </svg>
                                        </div>
                                        <div>
                                          <div className="ttl">
                                            {this.state.totalDisputed}
                                          </div>
                                          <div className="desc">Disputed</div>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="scroll-area">
                              <BootstrapTable
                                id={"timesheet"}
                                {...props.baseProps}
                                keyField="userUniqueno"
                                rowEvents={this.rowEvents}
                                hover
                                sort={{
                                  dataField: this.state.field,
                                  order: this.state.order,
                                }}
                                filter={filterFactory()}
                              />
                            </div>
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="Disputes" title="Disputes">
                  {" "}
                </Tab>
                <Tab eventKey="MyHours" title="My Hours">
                  {" "}
                </Tab>
              </Tabs>
            )}
            {this.state.hidValue !== "Select" &&
              this.state.showAddEntryModal && (
                <AddEntryModal
                callPage={"Timesheet"}
                  parentState={this.state}
                  hideAddEntryModal={this.hideAddEntryModal}
                  addEntryRefresh={this.addEntryRefresh}
                />
              )}
          </Container>
        </div>
      </>
    );
  }
}
